// extracted by mini-css-extract-plugin
module.exports = {"Newsletter":"Newsletter_Newsletter__3soGo","Checkbox":"Newsletter_Checkbox__2csEM"};